
import { Mapper } from "../../../../base/utils/mapper";
import { HistoryScholNeuropsychologyResponseModel } from "../../../../domain/models/consult/history-schol-neuropsychology-response.model";
import { HistoryScholNeuropsychologyResponseEntity } from "../entities/history-schol-neuropsychology-response.entity";

    export class HistoryScholNeuropsychologyImplementationRepositoryMapper extends Mapper<HistoryScholNeuropsychologyResponseModel, HistoryScholNeuropsychologyResponseEntity>{
        mapFrom(param:  HistoryScholNeuropsychologyResponseEntity):  HistoryScholNeuropsychologyResponseModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  HistoryScholNeuropsychologyResponseModel):  HistoryScholNeuropsychologyResponseEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }